document.addEventListener('DOMContentLoaded', function() {
    const prevButton = document.querySelector('.previous-product');
    const nextButton = document.querySelector('.next-product');

    if (prevButton) {
        prevButton.addEventListener('click', function(event) {
            event.preventDefault();
            window.location.href = prevButton.href;
        });
    }

    if (nextButton) {
        nextButton.addEventListener('click', function(event) {
            event.preventDefault();
            window.location.href = nextButton.href;
        });
    }
});
